import { BrowserModule, Title } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ScrollToModule } from "@nicky-lenaers/ngx-scroll-to";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import {
  FontAwesomeModule,
  FaIconLibrary,
} from "@fortawesome/angular-fontawesome";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";

import { AppComponent } from "./app.component";
import { EducationComponent } from "./education/education.component";
import { ExperienceComponent } from "./experience/experience.component";
import { SkillsComponent } from "./skills/skills.component";
import { ProjectsComponent } from "./projects/projects.component";
import { SummaryComponent } from "./summary/summary.component";
import { NavComponent } from "./nav/nav.component";
import { HeaderComponent } from "./header/header.component";
import { CommonModule } from "@angular/common";
import { RoundupsComponent } from "./roundups/roundups.component";
import { AtlassianComponent } from './atlassian/atlassian.component';

const appRoutes: Routes = [
  { path: "", component: SummaryComponent },
  { path: "summary", component: SummaryComponent },
  { path: "skills", component: SkillsComponent },
  { path: "education", component: EducationComponent },
  { path: "experience", component: ExperienceComponent },
  { path: "projects", component: ProjectsComponent },
];

@NgModule({
  declarations: [
    AppComponent,
    EducationComponent,
    ExperienceComponent,
    SkillsComponent,
    ProjectsComponent,
    SummaryComponent,
    NavComponent,
    HeaderComponent,
    RoundupsComponent,
    AtlassianComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule,
    ScrollToModule.forRoot(),
    CommonModule,
    NgbModule,
    FontAwesomeModule,
  ],
  providers: [Title],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas, fab);
  }
}
